import {Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup, NgModel, ReactiveFormsModule} from "@angular/forms";
import {CommonModule, NgClass} from "@angular/common";
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'labeled-input',
  templateUrl: './labeled-input.component.html',
  imports: [CommonModule, ReactiveFormsModule, NgbTooltipModule],
  standalone: true
})
export class LabeledInputComponent implements OnInit {
  groupNameDefined: boolean = false;
  @Input() form!: FormGroup;
  @Input() formName!: string;
  @Input() name!: string;
  @Input() type: string = 'text';
  @Input() required = false;
  @Input() readonly = false;
  @Input() autofocus = false;
  @Input() class: string | string[] | Set<string> | { [klass: string]: any } = 'form-control';
  @Input() style: string = '';
  @Input() placeholder: string = '';

  constructor() {
  }

  ngOnInit() {
    if (!this.form || !this.formName) {
      throw new Error('LabeledInputComponent: [form] and [formName] are required inputs.');
    }
  }

  get control(): FormControl {
    return this.form.get(this.formName) as FormControl;
  }

  get dirty(): boolean {
    return !!this.control?.dirty;
  }

  get touched(): boolean {
    return !!this.control?.touched;
  }

  get invalid() {
    return !!this.control?.invalid;
  }

}
